module.exports = __webpack_public_path__ + "media/images/education/avatar-nikolett-fc6f42c0855b8ddf8919410e588eb7af.png";